// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Vxl8y","head":"ProcedureTableInfo_head__1T2IM"};